import React from 'react';
import PropTypes from 'prop-types';

import './TextBox.scss';

const TextBox = ({ label, specification, type, className = '', ...rest }) => {
  return (
    <div className={className}>
      <div className="dazzle-label-text">{label}</div>
      <div
        className={
          specification
            ? 'phone-number-container flex-container'
            : 'phone-number-container'
        }
      >
        {specification && (
          <span className="sepecification">{specification}</span>
        )}
        {type === 'textArea' ? (
          <textarea
            className="text-box-dazzle textArea"
            type={type}
            {...rest}
          />
        ) : (
          <input className="text-box-dazzle" type={type} {...rest} />
        )}
      </div>
    </div>
  );
};

TextBox.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  specification: PropTypes.string,
};

export default TextBox;
